<script setup>
import {ref} from "vue";
import createTenantClub from "./components/createTenantClub/index.vue"
import {addClubIgnore} from "@/api/club/ignoreTenant.js";
import router from "@/router/index.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  tenantId: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
  },
  contactName: null,
  phone: null,
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: "Coming Soon ...",
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  assistsOperation: true
})
// 处理表单提交新建俱乐部
const handleCreateTenantClub = async () => {
  try {
    loading.value = true
    await addClubIgnore(ruleForm.value)
    router.push({ path: "/listTenantClub" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantClub v-model="ruleForm" @success="handleCreateTenantClub"></createTenantClub>
  </div>
</template>

<style scoped>

</style>
